<template>
  <div>
    <ul v-if="messages && messages.length>0" class="w-3/4 mx-auto">
      <li v-for="sender in senders" :key="sender">
        <ul class="mt-10
          border border-beige-academy-300" >
          <li v-for="message in messagesByUser(sender)" :key="message.id"
            class="p-4 text-sm border-b border-beige-academy-300 flex flex-col
               text-left"
            :class="bgMessage(message.read)"  >
            <div class="flex font-bold text-lg text-black">
              <div class="uppercase pr-4">
                {{ message.from_user.name }}:
              </div>
              <div>
                [ {{ message.subject }} ]
              </div>

            </div>
            <div class="text-md text-black">
              {{ message.body }}
            </div>
            <div class="flex justify-end text-md pt-4">
              <button class="p-2 uppercase mr-4 border border-beige-academy-300 px-4"
                :class="buttonClass(message.read)" @click="answer(message)">
                  {{ $t('messages.answer') }}
              </button>
              <button class="p-2 uppercase border border-beige-academy-300 px-4"
                v-if="message.read === 0" @click="readMessage(message.id)"
                :class="buttonClass(message.read)">
                  {{ $t('messages.read') }}
              </button>
              <button class="p-2 uppercase border border-beige-academy-300 px-4"
                v-else @click="unreadMessage(message.id)" :class="buttonClass(message.read)">
                  {{ $t('messages.unread') }}
              </button>
            </div>
          </li>
        </ul>
      </li>
    </ul>

    <h5 v-else class="flex justify-center font-sans-serif">
      {{$t('messages.none-received')}}
    </h5>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import axios from 'axios';
import MessageForm from '@/components/modals/MessageForm.vue';
import store from '../store';

export default {
  data() {
    return {
      senders: [],
    };
  },

  computed: {
    ...mapGetters({
      user: 'auth/user',
      messages: 'auth/receivedMessages',
    }),
  },

  created() {
    if (this.messages) this.setSenders();
  },

  beforeUpdate() {
    if (this.messages) this.setSenders();
  },

  methods: {
    setSenders() {
      this.senders = [];
      this.messages.forEach((message) => {
        if (!this.senders.includes(message.from_user_id)) this.senders.push(message.from_user_id);
      });
    },

    messagesByUser(id) {
      if (this.messages) { return this.messages.filter((message) => message.from_user_id === id); }
      return '';
    },

    bgMessage(read) {
      if (read === 0) return 'bg-beige-academy-300 bg-opacity-20';
      return 'bg-white';
    },

    buttonClass(read) {
      if (read === 0) return 'bg-white text-beige-academy-300 hover:text-white hover:bg-beige-academy-300';
      return 'text-white bg-beige-academy-300 hover:bg-white hover:text-beige-academy-300';
    },

    readMessage(id) {
      axios.put(`/api/messages/${id}/read`).then(() => {
        store.dispatch('auth/getReceivedMessages');
      }).catch((errors) => {
        console.log(errors);
      });
    },
    unreadMessage(id) {
      axios.put(`/api/messages/${id}/unread`).then(() => {
        store.dispatch('auth/getReceivedMessages');
      }).catch((errors) => {
        console.log(errors);
      });
    },

    answer(message) {
      this.readMessage(message.id);
      this.$modal.show(
        MessageForm, { fromUser: this.user, toUser: message.from_user, subj: message.subject },
        { adaptive: true, draggable: true },
      );
    },
  },

};
</script>
